export const PRODUCT = "PRODUCT";
export const productDetailsAction = (data) => {
    return {
        type: PRODUCT,
        payload:data
    }
}